// extracted by css-extract-rspack-plugin
export default {"close-icon":"close-icon-i1adl1","closeIcon":"close-icon-i1adl1","template-infos-options":"template-infos-options-FE02nn","templateInfosOptions":"template-infos-options-FE02nn"};